import { _ as _defineProperty, a as _slicedToArray } from '../_chunks/dep-50ece1d9.js';
import { u as useApiProps, _ as _toConsumableArray } from '../_chunks/dep-f0ef67c3.js';
import { _ as _objectWithoutProperties } from '../_chunks/dep-06688d2c.js';
import React, { forwardRef, useState, useEffect, useCallback } from 'react';
import '../util/use-size-props.js';
import '../util/use-common-classname.js';
import '../util/use-config.js';

var _excluded = ["colors", "className", "id", "hover", "size", "disabled", "style", "color", "onMouseEnter", "onMouseLeave"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CurIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$colors = props.colors,
    colors = _props$colors === void 0 ? [] : _props$colors,
    className = props.className,
    _props$id = props.id,
    id = _props$id === void 0 ? "" : _props$id,
    _props$hover = props.hover,
    hover = _props$hover === void 0 ? "" : _props$hover,
    size = props.size,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    style = props.style,
    color = props.color,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    resultProps = _objectWithoutProperties(props, _excluded);
  var _useApiProps = useApiProps({
      className: className,
      initColor: ["currentColor"],
      initName: "cur",
      colors: colors,
      id: id,
      hover: hover,
      size: size,
      style: style,
      disabled: disabled,
      color: color
    }),
    sizeStyle = _useApiProps.sizeStyle,
    cls = _useApiProps.cls;
  var _useState = useState(["currentColor"]),
    _useState2 = _slicedToArray(_useState, 2),
    colorList = _useState2[0],
    setColorList = _useState2[1];
  var _useState3 = useState(["currentColor"]),
    _useState4 = _slicedToArray(_useState3, 2),
    colorsProps = _useState4[0],
    setColorsProps = _useState4[1];
  var _useState5 = useState(["currentColor"]),
    _useState6 = _slicedToArray(_useState5, 2),
    defaultColor = _useState6[0],
    _ = _useState6[1];
  useEffect(function () {
    if (typeof colors === "string" && "cur".indexOf("-colored") === -1) {
      var col = JSON.parse(JSON.stringify(["currentColor"]));
      var find = col.find(function (item) {
        return item === "currentColor";
      });
      var _col = col;
      if (find) {
        _col = col.map(function (item) {
          if (item === "currentColor") {
            item = colors;
          }
          return item;
        });
      } else {
        _col[0] = colors;
      }
      setColorList(_col);
      setColorsProps(_col);
    }
    if (colors instanceof Array && "cur".indexOf("-colored") === -1) {
      var colorList1 = JSON.parse(JSON.stringify(["currentColor"]));
      colors.forEach(function (col) {
        var findColorIndex = colorList1.findIndex(function (v) {
          return v === col.targetColor;
        });
        if (findColorIndex >= 0) {
          colorList1[findColorIndex] = col.reviseColor;
        }
      });
      setColorList(_toConsumableArray(colorList1));
      setColorsProps(_toConsumableArray(colorList1));
    }
    if (color && typeof color === "string" && "cur".indexOf("-colored") === -1) {
      var _col2 = JSON.parse(JSON.stringify(["currentColor"]));
      var _find = _col2.find(function (item) {
        return item === "currentColor";
      });
      var _col3 = _col2;
      if (_find) {
        _col3 = _col2.map(function (item) {
          if (item === "currentColor") {
            item = color;
          }
          return item;
        });
      } else {
        _col3[0] = color;
      }
      setColorList(_col3);
      setColorsProps(_col3);
    }
  }, [JSON.stringify(colors), color, defaultColor]);
  var handleMouseEnter = useCallback(function (event) {
    onMouseEnter && onMouseEnter(event);
    if (!hover || hover.length === 0) return;
    if (colors instanceof Array && "cur".indexOf("-colored") === -1) {
      if (hover instanceof Array && "cur".indexOf("-colored") === -1) {
        var colorList1 = JSON.parse(JSON.stringify(colorList));
        hover.forEach(function (col) {
          var findColorIndex = colorList1.findIndex(function (v) {
            return v === col.targetColor;
          });
          if (findColorIndex >= 0) {
            colorList1[findColorIndex] = col.reviseColor;
          }
        });
        setColorList(_toConsumableArray(colorList1));
      }
    }
    if (typeof colors === "string" && "cur".indexOf("-colored") === -1) {
      if (typeof hover === "string") {
        var col = JSON.parse(JSON.stringify(colorList));
        var find = col.find(function (item) {
          return item === colors;
        });
        var _col = col;
        if (find) {
          _col = col.map(function (item) {
            if (item === colors) {
              item = hover;
            }
            return item;
          });
        } else {
          _col[0] = hover;
        }
        setColorList(_col);
      }
    }
    if (color && typeof color === "string" && "cur".indexOf("-colored") === -1) {
      if (typeof hover === "string") {
        var _col4 = JSON.parse(JSON.stringify(colorList));
        var _find2 = _col4.find(function (item) {
          return item === color;
        });
        var _col5 = _col4;
        if (_find2) {
          _col5 = _col4.map(function (item) {
            if (item === color) {
              item = hover;
            }
            return item;
          });
        } else {
          _col5[0] = hover;
        }
        setColorList(_col5);
      }
    }
    if (!color && colors.length === 0 && typeof hover === "string" && "cur".indexOf("-colored") === -1) {
      var _col6 = JSON.parse(JSON.stringify(colorList));
      var _find3 = _col6.find(function (item) {
        return item === "currentColor";
      });
      var _col7 = _col6;
      if (_find3) {
        _col7 = _col6.map(function (item) {
          if (item === "currentColor") {
            item = hover;
          }
          return item;
        });
      } else {
        _col7[0] = hover;
      }
      setColorList(_col7);
    }
    if (!color && colors.length === 0 && hover instanceof Array && "cur".indexOf("-colored") === -1) {
      var _colorList = JSON.parse(JSON.stringify(colorList));
      hover.forEach(function (col) {
        var findColorIndex = _colorList.findIndex(function (v) {
          return v === col.targetColor;
        });
        if (findColorIndex >= 0) {
          _colorList[findColorIndex] = col.reviseColor;
        }
      });
      setColorList(_toConsumableArray(_colorList));
    }
  }, [colorList, defaultColor, colors, color, hover]);
  var handleMouseLeave = useCallback(function (event) {
    onMouseLeave && onMouseLeave(event);
    if (!hover || hover.length === 0) return;
    var _defaultColor = JSON.parse(JSON.stringify(defaultColor));
    if (colorsProps) {
      _defaultColor = JSON.parse(JSON.stringify(colorsProps));
    }
    setColorList(_defaultColor);
  }, [colorsProps, defaultColor, hover]);
  return /* @__PURE__ */React.createElement("svg", _objectSpread(_objectSpread({
    id: "cur",
    style: sizeStyle,
    className: cls,
    ref: ref,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, resultProps), {}, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }), /* @__PURE__ */React.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */React.createElement("path", {
    d: "M7.99984 6.00008C6.89527 6.00008 5.99984 6.89551 5.99984 8.00008C5.99984 9.10465 6.89527 10.0001 7.99984 10.0001C9.10441 10.0001 9.99984 9.10465 9.99984 8.00008C9.99984 6.89551 9.10441 6.00008 7.99984 6.00008ZM4.6665 8.00008C4.6665 6.15913 6.15889 4.66675 7.99984 4.66675C9.84079 4.66675 11.3332 6.15913 11.3332 8.00008C11.3332 9.84103 9.84079 11.3334 7.99984 11.3334C6.15889 11.3334 4.6665 9.84103 4.6665 8.00008Z",
    fill: colorList[0],
    fillRule: "evenodd",
    clipRule: "evenodd",
    fillOpacity: "0.9"
  })));
});
CurIcon.displayName = "CurIcon";

export { CurIcon as default };
//# sourceMappingURL=cur.js.map
